export default{
  "Video Compressor": "Video Compressore",
  "HitPaw Online Video Compressor": "HitPaw Online Video Compressore",
  "Best video compressor tool to reduce video file size online without losing quality.": "Miglior strumento di compressione video per ridurre le dimensioni dei file video online senza perdere la qualità.",
  "Quality": "Qualità",
  "Small Size": "Piccola Dimensione ({{num}}%)",
  "High Quality": "Alta Qualità ({{num}}%)",
  "Frame Rate": "Velocità in Fotogrammi",
  "Resolution": "Risoluzione",
  "Keep Resolution": "Mantieni Risoluzione",
  "Format": "Formato",
  "Compress": "Comprimere",
  "Compressing": "Comprimendo",
  "Compress New": "Comprimere Nuovo",
  "xx% reduction in size!": "Riduzione delle dimensioni del volume del {{num}}%",
  "Compressed successfully, your file is now xxMB.": "Compresso con successo, il tuo file è ora <p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p>.",
  "Compression Failed": "Compressione fallita",
};